import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { put, takeLatest } from 'redux-saga/effects';
import { ActionWithPayload } from '../../../interface/ActionWithPayload';

// import { Search } from '../../../types/types';
import { getAllTransactionsDetails } from './TransactionsDetailsCRUD';

export enum ITransactionsDetailsActionTypes {
  GET_TRANSACTIONS_DETAILS = 'GET_TRANSACTIONS_DETAILS',
  FULL_FILL_TRANSACTIONS_DETAILS = 'FULL_FILL_TRANSACTIONS_DETAILS',
}

const initialTransactionsDetails: ITransactionsDetailsState = {
  transaction_details: undefined,
};

export interface ITransactionsDetailsState {
  transaction_details?: any;
}

export const reducer = persistReducer(
  { storage, key: 'USER_transaction_details', whitelist: [''] },
  (
    state: ITransactionsDetailsState = initialTransactionsDetails,
    action: ActionWithPayload<ITransactionsDetailsState>
  ) => {
    switch (action.type) {
      case ITransactionsDetailsActionTypes.FULL_FILL_TRANSACTIONS_DETAILS:
        return { ...state, transaction_details: action.payload?.transaction_details };
      default:
        return state;
    }
  }
);

export const actions = {
  getTransactionsDetails: ({ companyId, reportId, params }: any) => ({
    type: ITransactionsDetailsActionTypes.GET_TRANSACTIONS_DETAILS,
    payload: { companyId, reportId, params },
  }),
  fullFillTransactionsDetails: ({ transaction_details }: ITransactionsDetailsState) => ({
    type: ITransactionsDetailsActionTypes.FULL_FILL_TRANSACTIONS_DETAILS,
    payload: { transaction_details },
  }),
};

export function* getTransactionsDetails(action: ActionWithPayload<any>) {
  try {
    const { data } = yield getAllTransactionsDetails({
      companyId: action.payload?.companyId,
      reportId: action.payload?.reportId,
      params: action.payload?.params,
    });
    yield put(actions.fullFillTransactionsDetails({ transaction_details: data }));
  } catch (error) {
    //
  }
}

export function* saga() {
  yield takeLatest(
    ITransactionsDetailsActionTypes.GET_TRANSACTIONS_DETAILS,
    getTransactionsDetails
  );
}
